import React from 'react'
import { css } from '@emotion/core'

type BackButtonProps = {
  name?: string
  onClick?: () => void
}

export const BackButton: React.FC<BackButtonProps> = ({ name = '一覧へ戻る', onClick }) => {
  return (
    <div css={wrapperStyle} className={'field'}>
      <button onClick={onClick} css={buttonStyle}>
        {name}
      </button>
    </div>
  )
}

const wrapperStyle = css({})

const buttonStyle = css({
  border: '1px solid #757575',
  outoline: 'none',
  appearance: 'none',
  whiteSpace: 'nowrap',
  padding: '9px 13px 9px 30px',
  color: '#757575',
  borderRadius: '22px',
  fontSize: '12px',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  backgroundImage: `url(${require('@/static/images/back_arrow.svg')})`,
  backgroundPosition: 'left 10px center',
  backgroundSize: '14px',
  backgroundRepeat: 'no-repeat',
  '&:hover': {
    backgroundColor: '#EEEEEE',
  },
})
